module.exports = __webpack_public_path__ + "img/mobile/SmartButton-skip/btn-next-portrait-up@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-skip/btn-next-portrait-up@2x.png
// module id = 221
// module chunks = 0